import React from 'react'
import './ModalForm.css';
import GoogleLogin from 'react-google-login'
const ClientID = process.env.REACT_APP_CLIENT_ID
export default function Login() {
   const handleLoginSuccess = (response) => {
      console.log(response.profileObj);
    };
    
    const handleLoginFailure = (error) => {
      console.log(error)
    };
    
  return (
      <GoogleLogin
  clientId={ClientID}
  buttonText="Google"
  className='google-button m-auto bg-primary text-white'
  onSuccess={handleLoginSuccess}
  onFailure={handleLoginFailure}
  icon="fa-google"
/>
  )
}
